import { zip, unzip } from "../../../../lib/utils/zip.js";
import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class ZipStorageProvider extends AbstractStorageProvider {
  async get(key) {
    const value = await this.store.get(key);
    if (value) {
      return unzip(value);
    }
    return value;
  }
  async set(key, value) {
    this.store.set(key, zip(value));
  }
  async has(key) {
    return this.store.has(key);
  }
  async delete(key) {
    this.store.delete(key);
  }
}
export {
  ZipStorageProvider
};
//# sourceMappingURL=ZipStorageProvider.js.map
